import React, { useCallback, useEffect, useState } from 'react';

import { FormComponent, FormComponentProps } from '../../../components/form';
import css from './view-barn-component.module.css';
import Barn, { BarnAnimalSubGroups } from '../../../interfaces/barn';

export default function Barns(
  field: {
    name: string;
    mode: string;
    title?: string;
    components: () => FormComponent[];
  },
  barn: Barn
): FormComponent {
  return ({ ...rest }) => <BarnComponent field={field} barn={barn} {...rest} />;
}

export function BarnComponent({
  field,
  barn,
  ...rest
}: FormComponentProps & {
  field: {
    name: string;
    mode: string;
    title?: string;
    components: () => FormComponent[];
  };
  barn: Barn;
}) {
  const states = Array<Boolean>();
  for (let i = 0; i < barn.animal_species.length; i++) {
    states.push(false);
  }
  const [showStates, setShowStates] = useState(states);

  const [state, setState] = useState({
    barns: {} as { [key: string]: { components: FormComponent[] } },
  });

  const addBarn = useCallback(() => {
    setState((state) => {
      state.barns[0] = {
        components: field.components(),
      } as { components: FormComponent[] };

      return {
        ...state,
        barns: state.barns,
      };
    });
  }, [field]);

  useEffect(() => {
    addBarn();
    return;
  }, [addBarn]);

  const showAnimalGroups = (speciesId: string) => {
    setShowStates((prevShowStates) => {
      return {
        ...prevShowStates,
        [speciesId]: !prevShowStates[speciesId],
      };
    });
  };

  const AnimalGroups = () => {
    const info = [];
    info.push(
      <div className={css['species']}>
        <div className={css['title']}>Dzīvnieki</div>
        <div className={css['title']}>Dzīvnieku skaits</div>
      </div>
    );

    barn.animal_species.forEach((species) => {
      info.push(
        <div>
          <div className={css['speciesInfo']}>
            <div>
              <p
                className={css['info']}
                data-name={`animal_species_${species.name}`}
              >
                {species.name}
              </p>
            </div>
            <div>
              <p
                className={css['info']}
                data-name={`animal_species_count_${species.name}`}
              >
                {species.count}
              </p>
            </div>
            <button
              className={css['button']}
              type="button"
              name={`show_animal_groups_${species.name}`}
              onClick={() => showAnimalGroups(species.name)}
            >
              V
            </button>
          </div>
          {}
          {showStates[species.name] &&
            Object.values(species.groups).map((subGroup) => (
              <SubGroup
                key={subGroup.name}
                name={subGroup.name}
                count={subGroup.count}
                groups={subGroup.groups}
              />
            ))}
        </div>
      );
    });

    return info;
  };

  const SubGroup = ({
    name,
    count,
    groups,
    depth = 1,
  }: {
    name: string;
    count: number;
    groups: BarnAnimalSubGroups[];
    depth?: number;
  }) => {
    return (
      <div className={css['groupsInfo']}>
        <div className={css['infoRow']}>
          <span
            className={css['info']}
            style={{ paddingLeft: `${6 * depth}%` }}
          >
            {name}
          </span>
          <span className={css['count']}>{count}</span>
        </div>
        <div>
          {groups && (
            <div>
              {Object.values(groups).map((subGroup) => (
                <SubGroup
                  key={subGroup.name}
                  name={subGroup.name}
                  count={subGroup.count}
                  groups={subGroup.groups}
                  depth={depth + 1}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div>
      {Object.keys(state.barns).map((key: string, ind) => (
        <div
          className={
            field.mode === 'edit' ? css['barnInfoEdit'] : css['barnInfo']
          }
          key={key}
        >
          {state.barns[key].components.map((Child, ind2) => {
            return (
              <div>
                <Child key={ind2} {...rest} />
              </div>
            );
          })}
        </div>
      ))}
      <div className={css['animalInfo']}>{AnimalGroups()}</div>
    </div>
  );
}
